
    <h2 class="accordion-head" (click)="onClick($event)"><span class="questionId">{{questionId}}. </span>{{ title }}</h2>
    <div class="accordion-body" [class.active]="active">
      <ng-content></ng-content>
    </div>
  